import React, { FC, ReactNode } from 'react';
import { View } from 'react-native';

import { scale as initialScale } from '@components/frame';
import { SCREEN_BORDER_RADIUS, TEST_IDS } from '@v2/pages/common/constants/base.constants';
import TouchableElement from '@components/common/touchableElement';
import { GlassButton } from '@components/common/glassButton';
import Svg from '@styles/icons/svg';
import type { WithColor } from '@styles/colors';
import type { ScaleFunction } from '@components/operatorPanel/interfaces';

import type { ImageItem } from '@components/machines/components/detailsComponents/activeMachine/components/Images/types';

import { useManageImageWrapper } from '@components/machines/components/detailsComponents/activeMachine/components/Images/components/ImageWrapper/hooks/useManageImageWrapper';

export interface ImageWrapperProps extends WithColor {
  index?: number;
  imageDocumentId?: number | null;
  isImageHandlingNavigation?: boolean;
  documentRetrieveId?: number | string | null;
  documentRetrieveKey?: string;
  panelViewMode?: boolean;
  scale?: ScaleFunction;
  children: ReactNode;
  onImagePress?: (id: string) => void;
  id?: string;
  links?: ImageItem['links'];
  shouldDisplayFavorites?: boolean;
}

export const ImageWrapper: FC<ImageWrapperProps> = (props) => {
  const { panelViewMode, scale = initialScale, children, id } = props;

  const { isFavorite, onPress } = useManageImageWrapper(props);

  return (
    <TouchableElement testID={id ? TEST_IDS.imagesContainer.image(id) : undefined} onPress={onPress}>
      {({ boxStyle }) => (
        <View
          style={[
            boxStyle,
            {
              width: panelViewMode ? '100%' : scale(123),
              height: scale(panelViewMode ? 195 : 83),
              justifyContent: 'center',
              alignContent: 'center',
              alignItems: 'center',
              marginRight: scale(panelViewMode ? 0 : 4),
              marginBottom: scale(panelViewMode ? 15 : 0),
              position: 'relative',
              borderRadius: scale(SCREEN_BORDER_RADIUS),
              overflow: 'hidden',
            },
          ]}
        >
          {isFavorite && (
            <GlassButton
              style={{
                position: 'absolute',
                top: scale(5),
                left: scale(9),
                paddingVertical: scale(3),
                paddingHorizontal: scale(3),
                zIndex: 100000000,
                borderRadius: scale(25),
              }}
            >
              {(hovered: boolean) => (
                <Svg
                  icon="starSelected"
                  width={scale(22)}
                  height={scale(22)}
                  color={hovered ? 'Label/Light/Primary' : 'Label/Light/AlwaysDark  Primary'}
                />
              )}
            </GlassButton>
          )}
          {children}
        </View>
      )}
    </TouchableElement>
  );
};
